<div class="subscribers-page">
  <div class="d-flex justify-content-between align-items-center">
    <div class="content-search col-12  col-lg-6">
      <div class="search-container container-form d-flex align-items-center borderInput search-full">
        <i class="fal fa-search search-icon pointer-in" (click)="searchUser(searchInput.value)"></i>
        <input #searchInput class="input-custom w-100" type="text" placeholder="Buscar usuario" [(ngModel)]="searchText"
          (input)="searchUser(searchInput.value)">
      </div>
    </div>
    <!-- <div class="d-flex align-items-center justify-content-end content-btns col-6">
            <div class="btn-create m-0" [class.disabled]="activeSelectList" (click)="openCreateComunication()">
                <i class="fal fa-envelope"></i>
                <p class="m-0">Crear una comunicación para todos</p>
            </div>
        </div> -->
  </div>
  <div class="content-table-subscribers">
    <div *ngIf="loadingTable" class="container-lottie">
      <div class="loading-container">
        <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
          containerClass="loading-box"></ng-lottie>
      </div>
    </div>
    <div #containerScroll class="bg-transparent" *ngIf="loaded" (scroll)="isScrolledInfinityView($event)">
      <div class="desktop-view d-none d-lg-block table-subscribers table-panel multiple-lines">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z28" matSort (matSortChange)="sortData($event)">
          <!--<ng-container matColumnDef="options">
            <th mat-header-cell *matHeaderCellDef><b></b></th>
            <td mat-cell *matCellDef="let user">
            </td>
          </ng-container>-->
          <ng-container matColumnDef="name">
            <th mat-header-cell mat-sort-header *matHeaderCellDef><b>Nombre y apellidos</b></th>
            <td mat-cell *matCellDef="let user">
              {{user.name||'-'}}
            </td>
          </ng-container>
          <ng-container matColumnDef="email">
            <th mat-header-cell mat-sort-header *matHeaderCellDef><b>Correo electrónico</b></th>
            <td mat-cell *matCellDef="let user">
              {{user.email||'-'}}
            </td>
          </ng-container>
          <ng-container matColumnDef="purchases">
            <th mat-header-cell mat-sort-header *matHeaderCellDef><b>Compras</b></th>
            <td mat-cell *matCellDef="let user">
              {{user.total_orders||'-'}}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;">
          </tr>
        </table>
      </div>

      <div class="mobile-view d-lg-none px-3">
        <div class="row">
          <div class="col-12 col-md-6 mb-3" *ngFor="let user of dataSource.data">
            <div class="user-card bg-white rounded-3 p-2" (click)="openUser(user)">
              <div class="col-12">
                <div class="row">
                  <div class="col-12 mb-2 d-flex">
                    <div class="rounded-circle d-flex border-3 profile-image-circle overflow-hidden me-3">

                      <div class="d-flex justify-content-center align-items-center w-100 h-100">
                        <i class="fal fa-user-circle not-image-icon"></i>
                      </div>
                    </div>
                    <div>
                      <div class="d-flex align-items-center justify-content-between">
                        <div>
                          <p class="m-0 fw-bold">{{user.name||user.nombre||'-'}}</p>
                          <span class="text-primary text-truncate">{{user.email||'-'}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="col-12 mb-2 d-flex justify-content-end align-items-center h-100">
                  <i class="fal fa-shopping-cart text-primary me-2"></i>
                  <span class="info-text">{{user.total_orders||'-'}}</span>
                </div>
              </div>
              <!--<div class="col-1">
            <div class="d-flex align-items-start justify-content-center h-100">
              <i class="icon-option fal fa-ellipsis-vertical"></i>
            </div>
          </div>-->
            </div>
          </div>
        </div>
      </div>

      <div class="pagination-component">
        <div class="d-flex align-items-center pagination-panel pagination-table" *ngIf="!finishScroll">
          <div>
            <ng-lottie class="lottie-pagination" [options]="{path: 'assets/lotties/loading.json'}"
              containerClass="loading-box"></ng-lottie>
          </div>
        </div>
      </div>
    </div>
    <div class="empty-state" *ngIf="loaded && !loadingTable && (users.length<=0)">
      <i class="fal fa-users empty-state-icon"></i>
      <p class="empty-state-title">No se encontraron usuarios</p>
    </div>
  </div>
</div>
